import { configureStore } from '@reduxjs/toolkit'
import appReducer from './slices/appSlice'
import imageReducer from './slices/imageSlice'

export const store = configureStore({
  reducer: {
    app: appReducer,
    image: imageReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // 忽略这些路径的序列化检查
        ignoredActions: ['image/setUploadedImage'],
        ignoredPaths: ['image.uploadedImage'],
      },
    }),
})
